import { useEffect } from "react";

import { ServerError } from "@hl/shared-features/lib/features/layout";
import { Container, Group, Loader, Stack, Text, Title } from "@mantine/core";
import { useSearchParams } from "react-router-dom";

import { TOOLS_URL } from "config";
import { useVerifyEmailMutation } from "~/features/account/settings.graphql.generated";

export const EmailVerify = () => {
  const [searchParams] = useSearchParams();

  const verifyCode = searchParams.get("verifyCode");
  const redirectUrl = searchParams.get("redirectUrl") || TOOLS_URL.home;

  const [verifyEmailMutation, { loading, error }] = useVerifyEmailMutation();

  useEffect(() => {
    const verifyEmailMutationAsync = async () => {
      if (verifyCode) {
        await verifyEmailMutation({
          variables: {
            verifyCode,
          },
          onCompleted: () => {
            setInterval(() => (window.location.href = redirectUrl), 3000);
          },
        });
      }
    };
    verifyEmailMutationAsync();
  }, [verifyCode, redirectUrl]);

  if (!verifyCode) {
    return <ServerError />;
  }

  if (loading) {
    return (
      <Container>
        <Group mt="xl">
          <Loader color="dark" />
          <Title order={4}>Verifying email...</Title>
        </Group>
      </Container>
    );
  }

  if (error) {
    return (
      <Container>
        <Stack mt="xl" align="center">
          <Title order={4}>Failed to verify email</Title>
          <Text>
            Please try again or contact support if the error persists.
          </Text>
        </Stack>
      </Container>
    );
  }

  return (
    <Container>
      <Stack mt="xl" align="center">
        <Title order={4}>Email verified successfully!</Title>
        <Text>You&apos;ll be redirected soon...</Text>
      </Stack>
    </Container>
  );
};
